"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, spacing, typography }) => ({
    headerContainer: {
        marginBottom: spacing(1.25),
    },
    sectionHeadline: {
        marginBottom: spacing(2),
        fontWeight: typography.fontWeightLight,
        lineHeight: 1,
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: spacing(4),
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: spacing(1),
        color: palette.text.secondary,
    },
    iconSpacing: {
        marginRight: spacing(1),
    },
    underConstruction: {
        display: 'block',
        width: '50%',
        marginTop: spacing(5),
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});
exports.default = styles;
